// Nome exibido para um gestor na linha do tempo do card da Realização Destaque (`task-item` e
// `task-item-mad`). O cadastro (player_fields__c) traz `nome_guerra` em branco para parte dos
// gestores (ex.: inativos vindos da carga do BB); sem este fallback o card mostrava o status da
// etapa sem ninguém ao lado (GES-02, 22/10/2026).

export interface GestorComNome {
  nome_guerra?: string | null;
  nome?: string | null;
}

export function nomeExibicaoGestor(gestor?: GestorComNome | null): string {
  const nomeGuerra = gestor?.nome_guerra?.trim();
  if (nomeGuerra) return nomeGuerra;

  return gestor?.nome?.trim() ?? '';
}
